const iconPaths = {
  menu: "M4 6h16M4 12h16M4 18h16",
  close: "M6 6l12 12M18 6 6 18",
  search: "M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16m6-2 4 4",
  expand_more: "M6 9l6 6 6-6",
  arrow_forward: "M5 12h14M14 7l5 5-5 5",
  arrow_back_ios_new: "M15 5l-7 7 7 7",
  arrow_forward_ios: "M9 5l7 7-7 7",
  security: "M12 3l8 3v5c0 5-3 9-8 11-5-2-8-6-8-11V6zM9 12l2 2 4-5",
  verified_user: "M12 3l8 3v5c0 5-3 9-8 11-5-2-8-6-8-11V6zM8 12l2.5 2.5L16 9",
  gpp_maybe: "M12 3l8 3v5c0 5-3 9-8 11-5-2-8-6-8-11V6zM12 8v5M12 17h.01",
};

export function Icon({ name, className = "" }) {
  return (
    <svg
      className={`material-icons sq-vector-icon ${className}`}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path d={iconPaths[name] || iconPaths.security} />
    </svg>
  );
}
